import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const ClimateImages = ({ id }) => {
    const data = useStaticQuery(graphql`
        query {
            cover_1: file(relativePath: { eq: "climate/motif/cover_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_2: file(relativePath: { eq: "climate/motif/cover_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_3: file(relativePath: { eq: "climate/motif/cover_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_4: file(relativePath: { eq: "climate/motif/cover_4.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_5: file(relativePath: { eq: "climate/motif/cover_5.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            cover_6: file(relativePath: { eq: "climate/motif/cover_6.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

            motif_1: file(relativePath: { eq: "climate/motif/motif_1.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_2: file(relativePath: { eq: "climate/motif/motif_2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            motif_3: file(relativePath: { eq: "climate/motif/motif_3.png" }) {
                childImageSharp {
                    fluid(maxWidth: 500) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <Img style={{ width: "100%" }} fluid={data[id].childImageSharp.fluid} />
    )
}

export default ClimateImages
